import React from 'react';
import { Text } from '@spark';

/**
 * Input / Output card of the compare grid (Figma .ModelSetup-CompareIo):
 * 12px-radius bordered card, 16px padding, small header row with the card
 * name on the left and actions on the right.
 */
const ResponseStepCard = ({ stepNumber, title, subtitle, extra, children }) => (
    <div className="response-step-card">
        <div className="response-step-card__header">
            {stepNumber != null && (
                <div className="response-step-card__badge">{stepNumber}</div>
            )}
            <div className="response-step-card__titles">
                <Text variant="detail-regular" color="secondary" as="div">{title}</Text>
                {subtitle && (
                    <Text variant="detail-regular" color="secondary" as="div">{subtitle}</Text>
                )}
            </div>
            {extra && <div className="response-step-card__extra">{extra}</div>}
        </div>
        <div className="response-step-card__body">
            {children}
        </div>
    </div>
);

export default ResponseStepCard;
